import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';

export default function Ban(): JSX.Element {
  return (
    <div className='width-100vw height-100vh flex flex-column justify-content-center align-items-center'>
      <FontAwesomeIcon icon={faBan} color='red' size='2xl' />
      <h3>Request can not be processed</h3>
    </div>
  );
}